export default __webpack_public_path__ + "static/andy bedard-0ad2200bdebc3437a46b627b56599752.webp";